import React from 'react'

const MalaysiaAirportAcademy = () => {
  return (
    <div>
      MalaysiaAirportAcademy
    </div>
  )
}

export default MalaysiaAirportAcademy
